import { withExpoPublicEnvAliases } from "@vxrn/utils/publicEnv";
var ONE_PUBLIC_PREFIX = "ONE_PUBLIC_";
var ONE_PLATFORM_ENV = "ONE_PLATFORM";
function pickOnePublicEnv(env) {
  var picked = {};
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = Object.entries(env)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var [key, value] = _step.value;
      if ((key.startsWith(ONE_PUBLIC_PREFIX) || key.startsWith("EXPO_PUBLIC_")) && value !== void 0) {
        picked[key] = value;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return withExpoPublicEnvAliases(picked);
}
export {
  ONE_PLATFORM_ENV,
  ONE_PUBLIC_PREFIX,
  pickOnePublicEnv
};
//# sourceMappingURL=env.js.map
